import React from 'react';
import { GroupProps } from '@repo/ui/src/types/recipes';

const InlineIngredientSummary = ({ groupKey, ingredients, groupName }: GroupProps) => {
  return (
    <div key={groupKey} className="pb-6">
      <h6 className="tra-text-web-heading-7 text-left mb-0">{groupName}</h6>
      <ul className="list-none p-0 mt-4 gap-y-4 grid grid-cols-[max-content_1fr]">
        {ingredients.map((ingredient, i) => (
          <li key={`ingredient_${i}`} className="contents">
            <span className="tra-text-web-body-s mb-0 pr-2 border-r flex items-center">
              {ingredient.imperial?.measurementDisplay} {ingredient.unitOfMeasure}
            </span>
            <span
              itemProp="recipeIngredient"
              className="tra-text-web-body-l mb-0 pl-2 flex items-center"
            >
              {ingredient.ingredient?.name}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InlineIngredientSummary;
